import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { axiosPath, path } from "../../../../routing/helpers/router";
import minions from "../../../../minions/minions";
import useIsMounted from "../../../../layout/components/hooks/useIsMounted";
import CommunicationPipelineUserInquiryAddDefaultTemplate from "../../../../layout/screenSpecifics/Modules/CommunicationPipeline/User/CommunicationPipelineUserInquiryAddTemplates/CommunicationPipelineUserInquiryAddDefaultTemplate";
import CommunicationPipelineUserInquiryAddKeyserAndMackayTemplate from "../../../../layout/screenSpecifics/Modules/CommunicationPipeline/User/CommunicationPipelineUserInquiryAddTemplates/CommunicationPipelineUserInquiryAddKeyserAndMackayTemplate";
import errorHandler from "@/layout/components/error/ErrorHandler";
import * as currentPageAction from "@/store/actions/currentPageAction";
import { AppNoInfo } from "@/layout/AppComponents";
import CommunicationPipelineModuleSidebar from "@/layout/screenSpecifics/Modules/CommunicationPipeline/CommunicationPipelineModuleSidebar";

export default function CommunicationPipelineUserInquiryAddScreen() {
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const navigate = useNavigate();
  const [userType] = useState("user");
  const reportTemplate = useSelector(
    (state) => state.currentPage?.moduleData?.reportTemplate,
  );
  const [reportHex, setReportHex] = useState();
  const moduleData = useSelector((state) => state.currentPage?.moduleData);

  const handleAdd = useCallback(
    async (payload) => {
      axios
        .post(
          axiosPath("api_r_user_module_communicationPipeline_user_inquiry_add"),
          minions.forms.toFormData({
            ...payload,
            moduleBridgeHex,
            type: userType,
          }),
          { headers: { "Content-Type": "multipart/form-data" } },
        )
        .then((r) => {
          if (isMounted.current) {
            setReportHex(r?.data?.hex);
          }
        })
        .catch((e) => dispatch(errorHandler(e)));
    },
    [moduleBridgeHex, userType],
  );

  const handleOnFinish = useCallback(() => {
    navigate(
      path({
        name: "user_module_communicationPipeline_home",
        params: { moduleBridgeHex },
      }),
    );
  }, [moduleBridgeHex, reportHex]);

  // > LOAD MODULE DATA //
  useEffect(() => {
    axios
      .post(
        axiosPath("api_r_user_module_communicationPipeline_getModuleData"),
        { moduleBridgeHex },
      )
      .then((r) => {
        dispatch(currentPageAction.change("moduleData", r.data, true));
      });
  }, []);
  // > LOAD MODULE DATA //

  const renderTemplate = useCallback(() => {
    switch (reportTemplate) {
      case "keyserAndMackay":
        return (
          <CommunicationPipelineUserInquiryAddKeyserAndMackayTemplate
            reportHex={reportHex}
            onAdd={handleAdd}
            onFinish={handleOnFinish}
          />
        );
      default:
        return (
          <CommunicationPipelineUserInquiryAddDefaultTemplate
            reportHex={reportHex}
            onAdd={handleAdd}
            onFinish={handleOnFinish}
          />
        );
    }
  }, [reportTemplate, reportHex, handleAdd, handleOnFinish]);

  if (!moduleData) return <AppNoInfo />;

  return (
    <>
      {moduleData?.permissionLevel === 0 && (
        <CommunicationPipelineModuleSidebar />
      )}
      {renderTemplate()}
    </>
  );
}
